import React from 'react';
import PropTypes from 'prop-types';
import styles from '../shared/styles';
import { minLengthValidator, maxLengthValidator } from '../../../../helpers/validators';
import ValidatedInput from '../../../../components/inputs/validatedInput';
import { DivisionLabel } from '../shared/styled-components';

const Title = (props) => {
  const {
    label,
    value,
    required,
    placeholder,
    onChange,
  } = props;

  const requiredRender = (required) ? (
    <span style={styles.inputLabelRequire}>*</span>
  ) : null;

  return (
    <div className="row" style={styles.rowDivision}>
      <div id="title" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <DivisionLabel>
          {label} {requiredRender}
        </DivisionLabel>
        <ValidatedInput
          type="text"
          id="titleInputTest"
          styles={styles.inputTitle}
          placeholder={placeholder}
          wrapperStyle={styles.inputTitleWrapper}
          onChange={onChange}
          value={value}
          validators={[minLengthValidator.bind(null, required ? 1 : 0), maxLengthValidator.bind(null, 100)]}
        />
      </div>
    </div>
  );
};

Title.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

Title.defaultProps = {
  label: 'Title',
  value: '',
  required: false,
  placeholder: '',
  onChange: () => {},
};

export default Title;